import '../styles/Acts.css';
import { ServiceIcon } from './Icons';
import { scrollToEstimate } from '../utils/navigation';

function Acts({ title, description, icon }) {
  return (
    <article className="Act-Background">
      <div className="Act-Title-Img">
        <span className="Act-Icon"><ServiceIcon type={icon} /></span>
        <h3 className="Act-Title">{title}</h3>
      </div>
      <p className="Act-Desc">{description}</p>
      <button className="Act-Link" type="button" onClick={scrollToEstimate}>
        Get started <span aria-hidden="true">&rarr;</span>
      </button>
    </article>
  );
}

export default Acts;
